// Boton "Agregar a mi pedido" de la pagina de producto: agrega la variante al carrito ("Mi pedido")
// sin salir de la pagina, actualiza el numero del icono y muestra el aviso con "Seguir mirando" / "Ver mi pedido".
if (!customElements.get('deseo-agregar')) {
  customElements.define(
    'deseo-agregar',
    class DeseoAgregar extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.deseo-agregar__boton');
        this.dialog = this.querySelector('dialog');
        this.error = this.querySelector('[data-error]');
        this.variantId = this.dataset.variantId;

        this.button.addEventListener('click', () => this.add());
        this.querySelectorAll('[data-close]').forEach((button) => button.addEventListener('click', () => this.dialog.close()));
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data: { variant } }) => {
            this.variantId = variant ? variant.id : null;
            this.button.disabled = !variant || !variant.available;
          });
        }
      }

      disconnectedCallback() {
        this.unsubscribe?.();
      }

      async add() {
        if (!this.variantId || this.button.disabled) return;
        this.button.disabled = true;
        this.button.setAttribute('aria-busy', 'true');
        this.error.hidden = true;

        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(this.variantId), quantity: 1 }], sections: 'cart-icon-bubble' }),
          });
          const result = await response.json();

          if (!response.ok || result.status) {
            this.error.textContent = result.description || result.message || '';
            this.error.hidden = !this.error.textContent;
            return;
          }

          this.updateBubble(result.sections?.['cart-icon-bubble']);
          this.dialog.showModal();
        } catch (e) {
          console.error(e);
        } finally {
          this.button.disabled = false;
          this.button.removeAttribute('aria-busy');
        }
      }

      updateBubble(html) {
        const bubble = document.getElementById('cart-icon-bubble');
        if (!bubble || !html) return;
        const section = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (section) bubble.innerHTML = section.innerHTML;
      }
    }
  );
}
